export const sectionNames: any = {
  clinical_trail_details: 'Clinical Trial Details',
  site_adequacy: 'Site Adequacy',
  informed_consent: 'Informed Consent',
  adverse_event_reporting: 'Adverse Event Reporting',
  requirements_for_ecrf_completion: 'Requirements For Ecrf Completion',
  source_documentation: 'Source Documentation',
  monitoring: 'Monitoring',
  site_qualification_report: 'Qualification Report',
  mileStone: 'MileStone'
};
export const checkListQueries: any = {
  clinical_trails: {
    siv_report_protocol_version: {
      id: '',
      report_category: 'SUSIVRT',
      report_section_name: sectionNames.clinical_trail_details,
      report_field_name: 'siv_report_protocol_version',
      report_field_name_comm: 'siv_report_protocol_review_comm',
      report_field_label: 'Protocol Version x.xx',
      report_field_value: ''
    },
    siv_report_protocol_review: {
      id: '',
      report_category: 'SUSIVRT',
      report_section_name: sectionNames.clinical_trail_details,
      report_field_name: 'siv_report_protocol_review',
      report_field_name_comm: 'siv_report_protocol_review_comm',
      report_field_label:
        'Was the current version of the protocol thoroughly reviewed with the investigator and site staff?',
      report_field_value: ''
    },
    siv_report_study_objectives: {
      id: '',
      report_category: 'SUSIVRT',
      report_section_name: sectionNames.clinical_trail_details,
      report_field_name: 'siv_report_study_objectives',
      report_field_name_comm: 'siv_report_study_objectives_comm',
      report_field_label: 'Study Objectives',
      report_field_value: ''
    },
    siv_report_inclusion_exclusion: {
      id: '',
      report_category: 'SUSIVRT',
      report_section_name: sectionNames.clinical_trail_details,
      report_field_name: 'siv_report_inclusion_exclusion',
      report_field_name_comm: 'siv_report_inclusion_exclusion_comm',
      report_field_label:
        'Inclusion and exclusion criteria live demo of CRF was done during the visit (Inclusion and exclusion CRF)',
      report_field_value: ''
    },
    siv_report_study_design_timelines: {
      id: '',
      report_category: 'SUSIVRT',
      report_section_name: sectionNames.clinical_trail_details,
      report_field_name: 'siv_report_study_design_timelines',
      report_field_name_comm: 'siv_report_study_design_timelines_comm',
      report_field_label: 'Study design and timelines reviewed with site staff',
      report_field_value: ''
    },
    siv_report_soa: {
      id: '',
      report_category: 'SUSIVRT',
      report_section_name: sectionNames.clinical_trail_details,
      report_field_name: 'siv_report_soa',
      report_field_name_comm: 'siv_report_soa_comm',
      report_field_label: 'Schedule of assessments reviewed with site staff (SOA calendar)',
      report_field_value: ''
    },
    siv_report_enrollment_procedure: {
      id: '',
      report_category: 'SUSIVRT',
      report_section_name: sectionNames.clinical_trail_details,
      report_field_name: 'siv_report_enrollment_procedure',
      report_field_name_comm: 'siv_report_enrollment_procedure_comm',
      report_field_label: 'Screening and enrollment procedures reviewed (IRT manual and screening/ enrollment log)',
      report_field_value: ''
    },
    siv_report_lab_procedure: {
      id: '',
      report_category: 'SUSIVRT',
      report_section_name: sectionNames.clinical_trail_details,
      report_field_name: 'siv_report_lab_procedure',
      report_field_name_comm: 'siv_report_lab_procedure_comm',
      report_field_label:
        'Specimens/ samples to be obtained and frequency (lab procedures) reveiwed-Laboratory tour duing site visit-Kits and current inventory reviewed',
      report_field_value: ''
    },
    siv_report_ip_da: {
      id: '',
      report_category: 'SUSIVRT',
      report_section_name: sectionNames.clinical_trail_details,
      report_field_name: 'siv_report_ip_da',
      report_field_name_comm: 'siv_report_ip_da_comm',
      report_field_label:
        'Investigational product and drug administration procedures (Pharmacy procedures, Drug accountability log, Patient diary, drug destruction procedures)',
      report_field_value: ''
    },
    siv_report_protocol_deviation: {
      id: '',
      report_category: 'SUSIVRT',
      report_section_name: sectionNames.clinical_trail_details,
      report_field_name: 'siv_report_protocol_deviation',
      report_field_name_comm: 'siv_report_protocol_deviation_comm',
      report_field_label: 'Procedure for recording and reporting protocol deviations (Protocol deviations CRF)',
      report_field_value: ''
    },
    siv_report_other_procedures: {
      id: '',
      report_category: 'SUSIVRT',
      report_section_name: sectionNames.clinical_trail_details,
      report_field_name: 'siv_report_other_procedures',
      report_field_name_comm: 'siv_report_other_procedures_comm',
      report_field_label: 'Other protocol specific procedures',
      report_field_value: ''
    }
  },
  site_adequancy: {
    siv_report_fics_list: {
      id: '',
      report_category: 'SUSIVRT',
      report_section_name: sectionNames.site_adequacy,
      report_field_name: 'siv_report_fics_list',
      report_field_name_comm: 'siv_report_fics_list_comm',
      report_field_label:
        'Confirm if contact list is up to date in FICS and Delegation of Authority and SIV training forms are complete',
      report_field_value: ''
    },
    siv_report_contact_list: {
      id: '',
      report_category: 'SUSIVRT',
      report_section_name: sectionNames.site_adequacy,
      report_field_name: 'siv_report_contact_list',
      report_field_name_comm: 'siv_report_contact_list_comm',
      report_field_label: 'Contact list',
      report_field_value: ''
    },
    siv_report_doa: {
      id: '',
      report_category: 'SUSIVRT',
      report_section_name: sectionNames.site_adequacy,
      report_field_name: 'siv_report_doa',
      report_field_name_comm: 'siv_report_doa_comm',
      report_field_label: 'DOA',
      report_field_value: ''
    },
    siv_report_siv_training: {
      id: '',
      report_category: 'SUSIVRT',
      report_section_name: sectionNames.site_adequacy,
      report_field_name: 'siv_report_siv_training',
      report_field_name_comm: 'siv_report_siv_training_comm',
      report_field_label: 'SIV training log',
      report_field_value: ''
    },
    siv_report_study_supplies: {
      id: '',
      report_category: 'SUSIVRT',
      report_section_name: sectionNames.site_adequacy,
      report_field_name: 'siv_report_study_supplies',
      report_field_name_comm: 'siv_report_study_supplies_comm',
      report_field_label: 'Verify that study supplies are adequate',
      report_field_value: ''
    }
  },
  informed_consent: {
    siv_report_protocol_version: {
      id: '',
      report_category: 'SUSIVRT',
      report_section_name: sectionNames.informed_consent,
      report_field_name: 'siv_report_protocol_version',
      report_field_name_comm: 'siv_report_ic_process_comm',
      report_field_label: 'Protocol Version x.xx',
      report_field_value: ''
    },
    siv_report_ic_process: {
      id: '',
      report_category: 'SUSIVRT',
      report_section_name: sectionNames.informed_consent,
      report_field_name: 'siv_report_ic_process',
      report_field_name_comm: 'siv_report_ic_process_comm',
      report_field_label: 'Was the process for conducting and documenting informed consent at site verified?',
      report_field_value: ''
    },
    siv_report_ic_template_translation: {
      id: '',
      report_category: 'SUSIVRT',
      report_section_name: sectionNames.informed_consent,
      report_field_name: 'siv_report_ic_template_translation',
      report_field_name_comm: 'siv_report_ic_template_translation_comm',
      report_field_label: 'Were all informed consent templates and translations verified at site?',
      report_field_value: ''
    },
    siv_report_ic_sdv_process: {
      id: '',
      report_category: 'SUSIVRT',
      report_section_name: sectionNames.informed_consent,
      report_field_name: 'siv_report_ic_sdv_process',
      report_field_name_comm: 'siv_report_ic_sdv_process_comm',
      report_field_label: 'Was the process of source data verification of ICFs discussed with the site?',
      report_field_value: ''
    }
  },
  adverse_event_reporting: {
    siv_report_ae_reporting: {
      id: '',
      report_category: 'SUSIVRT',
      report_section_name: sectionNames.adverse_event_reporting,
      report_field_name: 'siv_report_ae_reporting',
      report_field_name_comm: 'siv_report_ae_reporting_comm',
      report_field_label: 'Requirements for reporting AEs, SAEs, Pregnancies reviewed? (Link to AE, SAE CRF)',
      report_field_value: ''
    }
  },
  requirements_for_ecrf_completion: {
    siv_report_ecrf_guidelines: {
      id: '',
      report_category: 'SUSIVRT',
      report_section_name: sectionNames.requirements_for_ecrf_completion,
      report_field_name: 'siv_report_ecrf_guidelines',
      report_field_name_comm: 'siv_report_ecrf_guidelines_comm',
      report_field_label:
        'Was there review with study personnel of the requirements for CRF/ eCRF data entry standards and query response timelines?',
      report_field_value: ''
    },
    siv_report_data_changes: {
      id: '',
      report_category: 'SUSIVRT',
      report_section_name: sectionNames.requirements_for_ecrf_completion,
      report_field_name: 'siv_report_data_changes',
      report_field_name_comm: 'siv_report_data_changes_comm',
      report_field_label: 'Was review of data changes to source data in the patient’s records (FICS EMR) discussed?',
      report_field_value: ''
    }
  },
  source_documentation: {
    siv_report_source_doc_review: {
      id: '',
      report_category: 'SUSIVRT',
      report_section_name: sectionNames.source_documentation,
      report_field_name: 'siv_report_source_doc_review',
      report_field_name_comm: 'siv_report_source_doc_review_comm',
      report_field_label:
        'Source data examples outside of FICS reviewed with details regarding access for CRA discussed.',
      report_field_value: ''
    }
  },
  monitoring: {
    siv_report_monitoring_plan: {
      id: '',
      report_category: 'SUSIVRT',
      report_section_name: sectionNames.monitoring,
      report_field_name: 'siv_report_monitoring_plan',
      report_field_name_comm: 'siv_report_monitoring_plan_comm',
      report_field_label: 'Monitoring details and general plan provided to the site. Link to site monitoring plan',
      report_field_value: ''
    }
  },
  qualification_report: {
    sq_site_background: {
      id: '',
      report_category: 'SQREPT',
      report_section_name: sectionNames.site_qualification_report,
      report_field_name: 'sq_site_background',
      report_field_name_comm: '',
      report_field_label: 'Site Background',
      report_field_value: ''
    },
    sq_study_activities: {
      id: '',
      report_category: 'SQREPT',
      report_section_name: sectionNames.site_qualification_report,
      report_field_name: 'sq_study_activities',
      report_field_name_comm: '',
      report_field_label: 'Study Activities',
      report_field_value: ''
    },
    sq_add_site_info: {
      id: '',
      report_category: 'SQREPT',
      report_section_name: sectionNames.site_qualification_report,
      report_field_name: 'sq_add_site_info',
      report_field_name_comm: '',
      report_field_label: 'Additional Site Information',
      report_field_value: ''
    },
    sq_imp_manage: {
      id: '',
      report_category: 'SQREPT',
      report_section_name: sectionNames.site_qualification_report,
      report_field_name: 'sq_imp_manage',
      report_field_name_comm: '',
      report_field_label: 'IMP Management',
      report_field_value: ''
    },
    sq_site_facilities: {
      id: '',
      report_category: 'SQREPT',
      report_section_name: sectionNames.site_qualification_report,
      report_field_name: 'sq_site_facilities',
      report_field_name_comm: '',
      report_field_label: 'Site Facilities',
      report_field_value: ''
    },
    sq_study_records: {
      id: '',
      report_category: 'SQREPT',
      report_section_name: sectionNames.site_qualification_report,
      report_field_name: 'sq_study_records',
      report_field_name_comm: '',
      report_field_label: 'Study Records',
      report_field_value: ''
    },
    sq_regulatory: {
      id: '',
      report_category: 'SQREPT',
      report_section_name: sectionNames.site_qualification_report,
      report_field_name: 'sq_regulatory',
      report_field_name_comm: '',
      report_field_label: 'Regulatory',
      report_field_value: ''
    },
    sq_reg_approval_bodies: {
      id: '',
      report_category: 'SQREPT',
      report_section_name: sectionNames.site_qualification_report,
      report_field_name: 'sq_reg_approval_bodies',
      report_field_name_comm: '',
      report_field_label: 'Regulatory Including Approval Bodies',
      report_field_value: ''
    },
    sq_quality_compliance: {
      id: '',
      report_category: 'SQREPT',
      report_section_name: sectionNames.site_qualification_report,
      report_field_name: 'sq_quality_compliance',
      report_field_name_comm: '',
      report_field_label: 'Regulatory Compliance & Quality Management',
      report_field_value: ''
    },
    sq_overall_summ: {
      id: '',
      report_category: 'SQREPT',
      report_section_name: sectionNames.site_qualification_report,
      report_field_name: 'sq_overall_summ',
      report_field_name_comm: '',
      report_field_label: 'Overall Summary',
      report_field_value: ''
    },
    sq_action_items: {
      id: '',
      report_category: 'SQREPT',
      report_section_name: sectionNames.site_qualification_report,
      report_field_name: 'sq_action_items',
      report_field_name_comm: '',
      report_field_label: 'Action Items',
      report_field_value: ''
    }
  },

  mileStone_report: {
    id: '',
    report_id: '',
    report_category: 'SUMILST',
    report_section_name: sectionNames.mileStone,
    report_field_name: '',
    report_field_name_comm: '',
    report_field_label: '',
    report_field_value: ''
  }
};
